module.exports = __webpack_public_path__ + "img/2.612ab4ec.svg";